export const ErrorMessages = {
    noCompanySlug: 'Please use your company-specific login URL.',
    default: 'Sorry, an unexpected error has occurred.',
};
